import { motion } from 'motion/react'
import { useEffect } from 'react'
import { VideoJumbo } from '#app/components/marketing/video-jumbo.tsx'

// Splash screen timing (in milliseconds)
const SPLASH_FADE_DELAY = 1500 // Video plays for 1.5s
const SPLASH_FADE_DURATION = 600 // Then fades out over 0.6s
const SPLASH_TOTAL_DURATION = SPLASH_FADE_DELAY + SPLASH_FADE_DURATION // 2100ms total

type SplashProps = {
	onComplete: () => void
}

export default function Splash({ onComplete }: SplashProps) {
	useEffect(() => {
		// Call onComplete when splash finishes
		const timer = setTimeout(() => {
			onComplete()
		}, SPLASH_TOTAL_DURATION)

		return () => {
			clearTimeout(timer)
		}
	}, [onComplete])

	return (
		<motion.div
			initial={{ opacity: 1 }}
			animate={{
				opacity: 0,
				transition: {
					delay: SPLASH_FADE_DELAY / 1000,
					duration: SPLASH_FADE_DURATION / 1000,
				},
			}}
			className="relative h-full w-full bg-black"
		>
			<VideoJumbo
				isIntersectingContent={false}
				srcMobile={'/videos/splash/vid-isotipo-ss-vertical.mp4'}
				srcDesktop={'/videos/splash/vid-isotipo-ss-horizontal.mp4'}
			/>
		</motion.div>
	)
}
